import React, { useState, useEffect } from "react";
import form from "../Form/Form.module.scss";
import styles from "./EditGalleryForm.module.scss";

import World from "../../world";
import Gallery from "../../types/Gallery";
import LogoContainer from "../LogoContainer";
import ActionLink from "../ActionLink";
import TextInput from "../TextInput";
import Submit from "../Submit";

import useUpdateGallery from "../../hooks/useUpdateGallery";

type WrapperProps = {
    world: World;
    name: string;
};

const Wrapper = (props: WrapperProps) => {
    const [gallery, setGallery] = useState<Gallery>(props.world.galleries[props.name]);
    const [err, setErr] = useState("");

    useEffect(() => {
        if (gallery) {
            return;
        }
        let active = true;

        (async function() {
            const [name, err] = await props.world.getGallery(props.name);
            if (err) {
                setErr(err.message);
                return;
            }
            if (active) {
                setGallery(props.world.galleries[name]);
            }
        }())

        return () => {
            active = false;
        };
    }, []);

    if (gallery) {
        return <EditGalleryForm world={props.world} gallery={gallery} />
    }

    if (err) {
        return (
            <>
                <h1>Failed to load</h1>
                <p>{err}</p>
            </>
        );
    }

    return <p>Loading...</p>
}

type Props = {
    world: World;
    gallery: Gallery;
};

const EditGalleryForm = (props: Props) => {
    const {
        isPending,
        isAvatarPending,
        err,
        avatar,
        onChangeDisplayName,
        onChangeDate,
        onChangeAvatar,
        onSubmit,
    } = useUpdateGallery(props.world, props.gallery);

    return (
        <div className={form["fullform"]}>
            <LogoContainer />

            {err && (
                <p><span className={form["form-error"]}>{err}</span></p>
            )}

            <img style={{width: "100%"}} className="banner-image" src={avatar} />

            <form onSubmit={onSubmit}>

                <div className={styles.picker} >
                    {isAvatarPending ? <p>Working...</p> : (
                        <label>
                            <input type="file" id="myFile" name="file" onChange={onChangeAvatar} />
                            Change Image
                        </label>
                    )}
                </div>

                <TextInput
                    name="display_name"
                    placeholder="Gallery Name (e.g. The Smith Wedding)"
                    help="Name Your Gallery"
                    defaultValue={props.gallery.display_name}
                    nocomplete
                    required
                    onChange={onChangeDisplayName} />

                <TextInput
                    name="date"
                    type="date"
                    required
                    placeholder="Your Wedding Date"
                    help="Enter Your Wedding Date"
                    defaultValue={props.gallery.date}
                    onChange={onChangeDate} />

                <Submit label="Save" is_pending={isPending} />
            </form>

            <ActionLink secondary to={`/dashboard/galleries/${props.gallery.id()}`}>
                cancel
            </ActionLink>
        </div>
    );
};

export default Wrapper;
